import { Injectable } from '@angular/core';
import { Logger, LoggerFactory } from '../core/logger.service';
import { TriggerbeeApi } from '../core/triggerbee/triggerbee-requester.service';
import { HttpRequestDecorator } from '../core/triggerbee/http.request.decorator';
import { Observable } from 'rxjs';
import { CustomerModel } from '../account-settings/models/customer.model';

@Injectable({
  providedIn: 'root',
})
export class CustomersService {
  private readonly logger: Logger;

  constructor(
    loggerFactory: LoggerFactory,
    private http: HttpRequestDecorator,
  ) {
    this.logger = loggerFactory.get('CustomersService');
  }

  private getGatewayResource(subResource?: string): string {
    return this.http.getBaseUrl(TriggerbeeApi.Gateway) + `/` + (subResource || '');
  }

  public getCustomer(id: string): Observable<CustomerModel> {
    return this.http.get(this.getGatewayResource(`customers/${id}`));
  }

  public updateCustomer(id: string, customer: CustomerModel): Observable<CustomerModel> {
    return this.http.put(this.getGatewayResource(`customers/${id}`), customer);
  }
}
